// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"358": "d6e808e040b3","494": "4077578422d4","6863": "454c9f289029","8357": "dd422574e14d","8795": "631c6af3ebb8",}[chunkId] + ".css"
}